import moment from "moment";

export default function update(state) {
    state.dashboard.dateRange.startDate = moment(state.dashboard.dateRange.startDate).format("YYYY-MM-DD");
    state.dashboard.dateRange.endDate = moment(state.dashboard.dateRange.endDate).format("YYYY-MM-DD");
    state.channel.allCustomCols = [];
    return state;
}
